

export const REACT_APP_BASE_URL_CC_NEW = "/api/v1/control-center-new/"
export const COOKIE_MAX_AGE = 86400;


export const EMAIL_HT = "Please enter the username";
export const PASSWORD_HT = "Please enter the password ";
